import React from "react";
const Footer = () =>{
    
    return(
        <small>
            Start2impact React Project || Anna Calabrese (2021)
        </small>
    )
}


export default Footer